var map = {
	"./aspanaes.png": 2797,
	"./cv.png": 8181,
	"./dg.png": 9399,
	"./enki.png": 4743,
	"./ffc.png": 8515,
	"./k.png": 2032,
	"./pc.png": 7531,
	"./pl.png": 1747,
	"./ts.png": 2161,
	"./usc.png": 1459,
	"./vodea.png": 2362,
	"./xg.png": 1606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8993;